import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { vendors } from "src/queries/vendors";

export const useVendorOptions = () => {
  const { data: vendorList } = useQuery({
    ...vendors.list,
    staleTime: 30000,
  });

  const vendorOptions = useMemo(
    () =>
      (vendorList ?? []).map(vendor => ({
        value: vendor.VENDOR_NAME,
        title: vendor.VENDOR_NAME,
        label: vendor.VENDOR_NAME,
      })),
    [vendorList],
  );

  return vendorOptions;
};
